/** ***********
*
* <user-right.selectors.ts v1.0>
*
* Copyright (c) 2023 AIRBUS OPERATIONS
*
* Contributors:
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*  NG6C740 [thomas.pereira.external@airbus.com]
*
* All rights reserved.
**************/

import { createSelector } from '@ngrx/store';
import { Group } from 'src/app/models/user-right';
import { AppState } from '../../store';

export const selectUserRightState$ = (state: AppState) => state.userRight;

export const selectUserRight$ = createSelector(selectUserRightState$, (userRight) => userRight?.data);

export const selectMyRightsTree$ = createSelector(selectUserRightState$, (userRight) => userRight?.data.myRightTree);

export const selectUserRightTree$ = createSelector(selectUserRightState$, (userRight) => userRight?.data.usersRightTree);

export const selectAllUsers$ = createSelector(selectUserRightState$, (userRight) => userRight?.data.allUsers);

export const selectUserLoaded$ = createSelector(selectUserRightState$, (userRight) => userRight?.usersLoaded);

export const selectManagers$ = createSelector(selectUserRightState$, (userRight) => userRight?.data.managers);

export const selectRightRequests$ = createSelector(selectUserRightState$, (userRight) => userRight?.data.rightRequests);

export const selectUserRightLoading$ = createSelector(selectUserRightState$, (userRight) => userRight?.loading);

export const selectUserRightLoaded$ = createSelector(selectUserRightState$, (userRight) => userRight?.loaded);

export const selectRequestsLoaded$ = createSelector(selectUserRightState$, (userRight) => userRight?.requestsLoaded);

export const selectGroupsLoaded$ = createSelector(selectUserRightState$, (userRight) => userRight?.groupsLoaded);

export const selectGroups$ = createSelector(selectUserRightState$, (userRight) => userRight?.data.groups);

export const selectGroupById$ = (id: Group['id']) => createSelector(selectUserRightState$, (userRight) => userRight?.data.groups.find(
    (group) => group.id === id
));

export const selectUsersOfGroupLoading$ = createSelector(selectUserRightState$, (userRight) => userRight?.groupUsersLoading);

export const selectUsersOfGroup$ = (group: Group) => createSelector(selectUserRightState$, (userRight) => userRight?.data.groups.find(({ id }) => id === group.id)?.users);

export const selectFamiliesOfGroupLoading$ = createSelector(selectUserRightState$, (userRight) => userRight?.groupFamiliesLoading);

export const selectFamiliesOfGroup$ = (group: Group) => createSelector(selectUserRightState$, (userRight) => userRight?.data.groups.find(({ id }) => id === group.id)?.families);

export const selectGroupsOfUser$ = createSelector(selectUserRightState$, (userRight) => userRight?.data.userGroups);

export const selectRequestGroups$ = createSelector(selectUserRightState$, (userRight) => userRight?.data.listOfGroups);
